module.exports = __webpack_public_path__ + "img/smartsemio.5f828dc2.png";